var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-container',{staticClass:"pt-7 pl-8 pr-8",attrs:{"fluid":true}},[(_vm.loading)?_c('div',{staticClass:"d-flex justify-center align-center"},[_c('app-spinner',{attrs:{"color":"primary","size":"xxl"}})],1):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }